import React, {useRef, useState} from 'react';
import {Button, Icon, useToaster} from '@gravity-ui/uikit';
import {Plus, TrashBin} from '@gravity-ui/icons';
import classNames from 'classnames';
import styles from './EntityImageUploadButton.module.scss';

interface EntityImageUploadButtonProps {
  imageUrl?: string | null;
  isUploading?: boolean;
  onFileSelect: (file: File) => void;
  onRemove?: () => void;
  className?: string;
  withBg?: boolean;
  notificationKey?: string;
}

export const EntityImageUploadButton = ({
  imageUrl,
  isUploading = false,
  onFileSelect,
  onRemove,
  className,
  withBg = true,
  notificationKey = 'entity-image-upload-error',
}: EntityImageUploadButtonProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [internalPreviewUrl, setInternalPreviewUrl] = useState<string | null>(null);
  const {add} = useToaster();

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!file.type.startsWith('image/')) {
        add({
          name: notificationKey,
          title: 'Ошибка загрузки изображения',
          content: 'Пожалуйста, выберите файл изображения.',
          theme: 'danger',
        });
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setInternalPreviewUrl(reader.result as string);
      };
      reader.readAsDataURL(file);
      onFileSelect(file);
      event.target.value = '';
    }
  };

  const handleRemove = () => {
    setInternalPreviewUrl(null);
    onRemove?.();
  };

  const previewUrl = internalPreviewUrl || imageUrl || null;
  const hasImage = Boolean(previewUrl);

  return (
    <>
      {!hasImage && (
        <div className={classNames(className, {[styles.imageUploadButtonWithBg]: withBg})}>
          <Button view="normal" size="xl" onClick={handleButtonClick} disabled={isUploading}>
            <Icon data={Plus} size={20} />
          </Button>
        </div>
      )}

      {hasImage && (
        <div className={styles.previewImageContainer}>
          <div className={styles.imagePreview}>
            <img src={previewUrl as string} alt="Превью" />
          </div>
          {onRemove && (
            <Button
              view="raised"
              size="xs"
              onClick={handleRemove}
              className={styles.removeImageBtn}
              disabled={isUploading}>
              <Icon data={TrashBin} size={14} />
            </Button>
          )}
        </div>
      )}

      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept="image/*"
        style={{display: 'none'}}
      />
    </>
  );
};
